export default "__VITE_ASSET__DVkxTK$n__"